import { NAV, CONTACT, ENASUSPRO_URL } from "@/data/content";

export const Footer = () => (
  <footer className="relative border-t border-white/10 py-16" data-testid="footer">
    <div className="ec-container">
      <div className="flex flex-col justify-between gap-10 md:flex-row">
        <div className="max-w-sm">
          <div className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-md bg-[#D4F870] font-display text-lg font-semibold text-[#0A0A0A]">e</span>
            <span className="font-display text-lg tracking-tight text-[#F3F4F6]">
              enasus<span className="text-[#D4F870]">carbon</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-[#9CA3AF]">
            Enasuspro® Carbon Ledger — ISO 14064, GHG Protokolü, CBAM ve ESRS/GRI uyumluluğu için karbon defteri.
          </p>
        </div>

        <div className="flex gap-16">
          <div>
            <div className="mb-4 text-xs uppercase tracking-widest text-[#4B5563]">Menü</div>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-[#9CA3AF] transition-colors hover:text-[#F3F4F6]">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mb-4 text-xs uppercase tracking-widest text-[#4B5563]">İletişim</div>
            <ul className="space-y-2 text-sm text-[#9CA3AF]">
              <li><a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-[#F3F4F6]">{CONTACT.email}</a></li>
              <li>{CONTACT.phone}</li>
              <li><a href={ENASUSPRO_URL} className="text-[#D4F870] transition-colors hover:text-[#BEF264]">enasuspro.com →</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 text-xs text-[#4B5563] md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} Enasuspro®. Tüm hakları saklıdır.</span>
        <span>Ataşehir, İstanbul – Türkiye</span>
      </div>
    </div>
  </footer>
);
